/**
 * New Title Levels
 */
export var TitleLevels;
(function (TitleLevels) {
    TitleLevels[TitleLevels["ONE"] = 1] = "ONE";
    TitleLevels[TitleLevels["TWO"] = 2] = "TWO";
    TitleLevels[TitleLevels["THREE"] = 3] = "THREE";
    TitleLevels[TitleLevels["FOUR"] = 4] = "FOUR";
    TitleLevels[TitleLevels["FIVE"] = 5] = "FIVE";
    TitleLevels[TitleLevels["SIX"] = 6] = "SIX";
})(TitleLevels || (TitleLevels = {}));
export var TitleMarkup;
(function (TitleMarkup) {
    TitleMarkup["H1"] = "h1";
    TitleMarkup["H2"] = "h2";
    TitleMarkup["H3"] = "h3";
    TitleMarkup["H4"] = "h4";
    TitleMarkup["H5"] = "h5";
    TitleMarkup["H6"] = "h6";
    TitleMarkup["P"] = "p";
    TitleMarkup["SPAN"] = "span";
    TitleMarkup["DIV"] = "div";
})(TitleMarkup || (TitleMarkup = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGl0bGVFbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vY29tcG9uZW50cy90aXRsZS9UaXRsZUVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxXQU9YO0FBUEQsV0FBWSxXQUFXO0lBQ3JCLDJDQUFPLENBQUE7SUFDUCwyQ0FBTyxDQUFBO0lBQ1AsK0NBQVMsQ0FBQTtJQUNULDZDQUFRLENBQUE7SUFDUiw2Q0FBUSxDQUFBO0lBQ1IsMkNBQU8sQ0FBQTtBQUNULENBQUMsRUFQVyxXQUFXLEtBQVgsV0FBVyxRQU90QjtBQU9ELE1BQU0sQ0FBTixJQUFZLFdBVVg7QUFWRCxXQUFZLFdBQVc7SUFDckIsd0JBQVMsQ0FBQTtJQUNULHdCQUFTLENBQUE7SUFDVCx3QkFBUyxDQUFBO0lBQ1Qsd0JBQVMsQ0FBQTtJQUNULHdCQUFTLENBQUE7SUFDVCx3QkFBUyxDQUFBO0lBQ1Qsc0JBQU8sQ0FBQTtJQUNQLDRCQUFhLENBQUE7SUFDYiwwQkFBVyxDQUFBO0FBQ2IsQ0FBQyxFQVZXLFdBQVcsS0FBWCxXQUFXLFFBVXRCIn0=